import { useState } from "react";
import { axiosPostApi } from "../../helpers/interceptorServices";

const useTableExport = (downloadExcel) => {
  const [exportLoading, setExportLoading] = useState(false);

  const exportAllData = async ({
    apiUrl,
    requestBody,
    headers,
    headerToKeyMap,
    fileName,
  }) => {
    try {
      setExportLoading(true);

      const response = await axiosPostApi(
        `${apiUrl}?pageSize=10000&pageNo=1`,
        requestBody
      );

      if (response?.data?.status && response?.data?.respCode === "00") {
        const apiData = response?.data?.data || [];

        const excelHeaders = headers.map((header) => ({
          label: header,
          key: headerToKeyMap[header],
        }));

        const excelData = apiData.map((item) => {
          const row = {};

          headers.forEach((header) => {
            const key = headerToKeyMap[header];
            row[key] = item[key] ?? "-";
          });

          return row;
        });

        downloadExcel(excelData, excelHeaders, fileName);
      }
    } catch (error) {
      console.error("Export Failed", error);
    } finally {
      setExportLoading(false);
    }
  };

  return { exportAllData, exportLoading };
};

export default useTableExport;